import { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AuthContext from "./AuthContext";
import axios from "axios";

function ProtectedWrapper(props) {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Add Axios response interceptor
    const interceptor = axios.interceptors.response.use(
      (response) => response, // Pass through successful responses
      (error) => {
        // Check for 403 status or invalid token message
        if (
          error.response?.status === 406 || error.response?.status === 403 || error.response?.status === 401 ||
          error.response?.status === 402 || error.response?.status === 404 || error.response?.status === 400
        ) {
          // Perform logout actions
          auth.setUser(null); // Clear user context
          navigate("/login", { replace: true }); // Redirect to login
        }
        return Promise.reject(error); // Propagate other errors
      }
    );

    return () => {
      // Cleanup interceptor on unmount
      axios.interceptors.response.eject(interceptor);
    };
  }, [auth, navigate]);

  if (!auth.user) {
    return <Navigate to="/login" replace />;
  }

  return props.children;
}

export default ProtectedWrapper;
